import { Pie } from '@ant-design/plots';
import PlotAutoFit from '../Layout/PlotAutoFit';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { myPalette } from '../Layout/Palettes';







const PiChart = () => {

  const data = [
    { type: 'itemitem1item1item11', value: 27, title: '11' },
    { type: 'item2', value: 25, title: '12' },
    { type: 'item3', value: 18, title: '13' },
    { type: 'item4', value: 15, title: '14' },
    { type: 'item5', value: 10, title: '15' },
    { type: 'item6', value: 5, title: '16' },
  ];


  const chartRef = useRef<any>(null);



  const handleSliceClick = useCallback((e: any) => {
    const datum = e?.data?.data; // دیتای آیتم کلیک‌شده
    console.log("Clicked:", datum);
    // اینجا هرکاری خواستی: روتینگ، فیلتر، مودال، ...
  }, []);

  useEffect(() => {
    return () => {
      const chart = chartRef.current;
      if (!chart) return;
      chart.off("interval:click", handleSliceClick);
      chart.off("element:click", handleSliceClick);
      chart.off("label:click", handleSliceClick);
    };
  }, [handleSliceClick]);

  const config = useMemo(
    () => ({
      data: data,
      angleField: 'value',
      colorField: 'type',
      innerRadius: 0.3,
      label: {
        text: 'title',
        style: {
          fontWeight: 'bold',
           fill: myPalette.labelCollor,
        },
      },
    legend: {
      color: {
        title: true,
        position: "right",
        orientation: "horizontal",
        rowPadding: 8,
        itemMarker: "circle",
        itemMarkerSize: 18,
        itemLabelFill: myPalette.labelCollor,
        itemLabelFontSize: 12,
        itemLabelTextAlign: "left",
        itemBackgroundFill: myPalette.backCollor,
        itemBackgroundRadius: 10,
        itemBackgroundStroke: "rgba(0, 0, 0, 0.35)",
        itemBackgroundLineWidth: 1,
      },
    },
      annotations: [
        {
          type: 'text',
          style: {
            text: '',
            x: '50%',
            y: '50%',
            textAlign: 'center',
            fontSize: 40,
            fontStyle: 'bold',
          },
        },
      ],
style: {
      stroke: 'transparent',
      inset:0.1,
      radius: 4,
    },
          scale: {
      color: {
        palette: myPalette.palette,
        offset: (t: any) => t * 0.8 + 0.1,
      },
    },
      interactions: [{ type: "element-active" }, { type: "element-selected" }],
      onReady: ({ chart }: any) => {
        chartRef.current = chart;
        chart.on("interval:click", handleSliceClick);
        chart.on("element:click", handleSliceClick);
        chart.on("label:click", handleSliceClick);
      },
    }),
    [data, handleSliceClick]
  );





  // const config = {
  //   data:data,
  //   angleField: 'value',
  //   colorField: 'type',
  //   innerRadius: 0.6,
  //   label: {
  //     text: 'title',
  //     style: {
  //       fontWeight: 'bold',
  //     },
  //   },
  //   legend: {
  //     color: { 
  //       title: true,
  //       position: 'right',
  //       rowPadding: 5,
  //     },
  //   },
  //   annotations: [
  //     {
  //       type: 'text',
  //       style: {
  //         text: '',
  //         x: '50%',
  //         y: '50%',
  //         textAlign: 'center',
  //         fontSize: 40,
  //         fontStyle: 'bold',
  //       },
  //     },
  //   ],

  // };
  return (
    <PlotAutoFit style={{ background: myPalette.backCollor }}>
      {({ width, height }) => (
        <>
          <Pie
            {...config}
            autoFit={false}
            width={width}
            height={height}
          />
        </>
      )}
    </PlotAutoFit>
  )
};
export default PiChart;


